export default __webpack_public_path__ + "static/media/SettingsOrange.1e523c30.svg";